<template>
  <div class="bs-wrapper downlaod">
    <div class="content">
      <div class="download-bg">
        <div class="app-logo"></div>
        <div class="download-name">万商服</div>
      </div>
      <div class="download-bot">
        <div class="app-desc">
          <p>
            万商服面向万达广场合作商户，其核心功能是将服务于商户的业务全面在线化、数字化。
          </p>
          <p>
            为商户提供一站式自助服务，让商户经营更加高效便捷，提高商户满意度。
          </p>
        </div>
        <div class="download-tip">
          <div class="has-downloaded">
            已安装，点击<span @click="handleOpenLink">此处</span>打开万商服
          </div>
          <div class="not-download">若未安装，请先下载应用</div>
        </div>
        <div class="download-btn" @click="handleDownload">去下载</div>
      </div>
    </div>
    <div class="downlaod-mask" v-show="isWeixin">
      <div class="tip-text-top">
        <div>点击右上角“...”，</div>
        <div class="tip-arrow"></div>
      </div>
      <div class="tip-text-bot">选择在浏览器中打开</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Download',

  mixins: [],

  components: {},

  props: {},

  data() {
    return {
      clientType: '',
      isWeixin: this.$bsUtils.isWeixin(),
    };
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {
    this.clientType = this.$bsUtils.getClientType();
    this.queryParms = this.$route.query;
  },

  destroyed() {},

  methods: {
    getNativePageUrl(params) {
      if (this.clientType == 'ios') return `wdmp://mp.wanda.cn/${params}`;
      if (this.clientType == 'android')
        return `wdmp://mp.wanda.cn?url=wdmp://mp.wanda.cn/${params}`;
    },
    handleOpenLink() {
      if (this.queryParms.type && this.queryParms.type === 'meeting') {
        let url = this.getNativePageUrl(
          `meetingMainDetail?id=${this.queryParms.id}`
        );
        if (!url) return;
        window.location.href = url;
      } else {
        let url = this.getNativePageUrl('mine');
        if (!url) return;
        window.location.href = url;
      }
    },
    handleDownload() {
      if (this.isWeixin) return;
      switch (this.clientType) {
      case 'android':
        window.open(
            'https://wicmp.wandawic.com/sgapp-res/act-static/app-publish/prod/%E4%B8%87%E5%95%86%E6%9C%8D.apk'
        );
        break;
      case 'ios':
        window.open('itms-apps://itunes.apple.com/cn/app/id1576824387');
        break;
      case 'pc':
        break;
      default:
        break;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.downlaod {
  background: url('../../assets/img/download/bg_downloadL@2x.png') no-repeat;
  background-size: 100% 100%;
  .download-bg {
    width: 100%;
    position: absolute;
    display: flex;
    flex-direction: column;
    justify-items: center;
    left: 50%;
    top: 35%;
    transform: translateX(-50%);
    .app-logo {
      width: 72px;
      height: 72px;
      margin: 0 auto 7px;
      background: url('../../assets/img/download/logo.png') no-repeat;
      background-size: 100%;
      z-index: 10;
      border-radius: 10px;
    }
  }
  .download-bot {
    position: absolute;
    overflow: auto;
    left: 50%;
    top: calc(35% + 116px);
    transform: translate(-50%);
    bottom: 25px;
  }
  @media screen and(max-height: 667px) {
    background: url('../../assets/img/download/bg_downloadS@2x.png') no-repeat;
    background-size: 100% 100%;
    .download-bg {
      top: 30%;
    }
    .download-bot {
      top: calc(30% + 116px);
    }
  }
  position: relative;
  .content {
    overflow-y: auto;
    text-align: center;
    font-size: 16px;
    color: #666666;
    & > div {
      line-height: 22px;
    }
  }

  .download-name {
    color: #333333;
    font-weight: bold;
    font-size: 24px;
    margin-bottom: 15px;
  }
  .app-desc {
    width: 300px;
    margin: 0 auto;
    font-size: 12px;
    padding: 12px;
    text-align: center;
    color: #8c7d7d;
    p {
      margin: 0;
    }
    background: linear-gradient(
      360deg,
      rgba(104, 241, 184, 0) 0%,
      rgba(228, 19, 53, 0.05) 41%,
      rgba(228, 19, 53, 0.05) 57%,
      rgba(228, 19, 53, 0) 100%
    );
  }
  .download-tip {
    color: #ab9e9e;
    font-size: 14px;
    margin: 12% 0 25px;
    .has-downloaded {
      span {
        color: #FF6F00;
      }
    }
  }
  .content .download-btn {
    margin: 0 auto 25px;
    line-height: 44px;
    color: #fff;
    width: 325px;
    height: 48px;
    background: #FF6F00;
    box-shadow: 0px 3px 12px 1px rgba(228, 19, 53, 0.35);
    border-radius: 24px;
  }
  .downlaod-mask {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.4);
    color: #fff;
    font-size: 18px;
    z-index: 20;
    & > div {
      line-height: 22px;
    }
    .tip-text-top {
      display: flex;
      align-items: flex-end;
      justify-content: flex-end;
      padding-right: 24px;
    }
    .tip-text-bot {
      text-align: right;
      padding-right: 51px;
    }
    .tip-arrow {
      width: 54px;
      height: 54px;
      background: url('../../assets/img/download/icon_arrow.png') no-repeat;
      background-size: 100%;
    }
  }
}
</style>
